/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "إلغاء"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "لقد حصلت على مبرر للنشاط التجاري من أجل الوصول إلى بيانات العملاء"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "سيتم تسجيل نشاط التنزيل وتتبعه لأغراض الامتثال الأمني"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "هل ترغب في المتابعة؟"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "بالتنزيل، فإنك تقر بما يلي:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
